const JotformEmbed = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <iframe
        src="https://form.jotform.com/240012133223434"
        title="Jotform Form"
        width="100%"
        height="800px"
        frameBorder="0"
        style={{ border: 'none' }}
      ></iframe>
    </div>
  );
};

export default JotformEmbed;
